<template>
  <div class="main">
    <headerBar current="links"></headerBar>
    <div class="banner">
      <div>
        <h3>联运通</h3>
        <h4>--涉铁物流企业的数字化运营管理平台</h4>
        <h5>履约追踪、电子运单、企业间结算、自备箱（车）等运输资产的运用位置和运用状态管理的一站式数字化运营解决方案</h5>
        <router-link tag="p" to="/solution">解决方案</router-link>
      </div>
    </div>
    <div class="introduction">
      <div class="content">
        <div>
          <img src="../assets/pc/icon-links1.png" alt="" />
          <h3>联运组织</h3>
          <p>
            阶段计划、日计划、请车、承认车、动态场存、在途管理等集成化、可视化
          </p>
        </div>
        <div>
          <img src="../assets/pc/icon-links2.png" alt="" />
          <h3>业财协同</h3>
          <p>
            运费、服务费、仓储费、装卸费等票据归集、核对，上下游企业结算、对账自动化
          </p>
        </div>
        <div>
          <img src="../assets/pc/icon-links3.png" alt="" />
          <h3>履约服务</h3>
          <p>
            客户、合同、项目、报价、供应商基础信息动态管理，业务履约情况统计、分析
          </p>
        </div>
        <div>
          <img src="../assets/pc/icon-links4.png" alt="" />
          <h3>资产管理</h3>
          <p>
            动态查询、运踪轨迹、发运数据呈现，定检信息、运费查询，总资产分布状态统计
          </p>
        </div>
        <div>
          <img src="../assets/pc/icon-links5.png" alt="" />
          <h3>经营支持</h3>
          <p>
            业务营销、生产运营、业财执行结果呈现，动态收支利统计，运营效率动态分析
          </p>
        </div>
      </div>
    </div>
    <div class="process"></div>
    <div class="ability">
      <h3>五种物流企业核心岗位数字化运营能力</h3>
      <ul>
        <li>
          <img src="../assets/pc/icon-ability1.png" alt="" />
          <p><i>商务营销</i>客户、合同、报价管理</p>
        </li>
        <li>
          <img src="../assets/pc/icon-ability2.png" alt="" />
          <p><i>生产运营</i>运力、运踪、场站、计划、供应商管理</p>
        </li>
        <li>
          <img src="../assets/pc/icon-ability3.png" alt="" />
          <p><i>业财务运营</i>运量、单据、资金、结算管理</p>
        </li>
        <li>
          <img src="../assets/pc/icon-ability4.png" alt="" />
          <p><i>经营管理者</i>收支利动态核算、监测，风险管控</p>
        </li>
        <li>
          <img src="../assets/pc/icon-ability5.png" alt="" />
          <p><i>系统管理员</i>基础数据维护、权限、系统运维管理</p>
        </li>
      </ul>
    </div>
    <contact></contact>
    <footerBar></footerBar>
  </div>
</template>

<script>
import headerBar from "../components/headerBar"
import contact from "../components/contact"
import footerBar from "../components/footerBar"
export default {
  components: { headerBar, contact, footerBar },
  data() {
    return {
      current: 3,
    }
  },
}
</script>

<style scoped>
.banner {
  background: url("../assets/pc/banner1.png") no-repeat center;
  background-size: 100%;
}

.banner div {
  height: 4.8rem;
  width: 13rem;
  margin: 0 auto;
  padding-top: 1rem;
}

.banner div h3 {
  font-size: 0.48rem;
  color: #fff;
  font-weight: bold;
}

.banner div h4 {
  font-size: 0.2rem;
  color: #fff;
  padding-top: 0.3rem;
  line-height: 0.4rem;
  font-weight: bold;
}

.banner div h5 {
  color: #fff;
  width: 4.4rem;
  font-size: 0.16rem;
  line-height: 0.28rem;
}

.banner div p {
  width: 1.9rem;
  font-size: 0.16rem;
  line-height: 0.54rem;
  text-align: center;
  color: #fff;
  background: #1070ff;
  cursor: pointer;
  margin-top: 0.5rem;
}

.introduction {
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.introduction .content div {
  height: 0.68rem;
  display: flex;
  align-items: center;
}

.introduction .content div img {
  width: 0.26rem;
}

.introduction .content div h3 {
  font-size: 0.22rem;
  color: #0b1d30;
  font-weight: bold;
  margin-left: 0.28rem;
}

.introduction .content div p {
  font-size: 0.16rem;
  color: #0b1d30;
  margin-left: 0.8rem;
}

.process {
  height: 6.18rem;
  background: url("../assets/pc/process.png") no-repeat center;
  background-size: 100%;
}

.ability {
  padding-top: 0.7rem;
}

.ability h3 {
  font-size: 0.3rem;
  color: #091c2e;
  font-weight: bold;
  text-align: center;
}

.ability ul {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 12.8rem;
  margin: 0.2rem auto 0;
}

.ability ul li {
  width: 6.3rem;
  height: 1.65rem;
  background: #fff;
  box-shadow: 0px 0px 0.24rem 0px rgba(153, 153, 153, 0.17);
  border-radius: 0.04rem;
  margin-top: 0.2rem;
  padding: 0.34rem 0.5rem 0;
}

.ability ul li img {
  height: 0.45rem;
}

.ability ul li p {
  margin-top: 0.28rem;
  color: #091c2e;
  font-size: 0.16rem;
}

.ability ul li p i {
  font-weight: bold;
  font-size: 0.2rem;
  margin-right: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/links.vue